import { KeyValue } from "@/main/models/common";
import { DistributionRegionFilterRequest } from "@/main/models/request";

export enum DistributionRegionTypes {
	GET_DISTRIBUTION_REGION = "@distributionRegion/GET_DISTRIBUTION_REGION",
	SAVE_DISTRIBUTION_REGION = "@distributionRegion/SAVE_DISTRIBUTION_REGION",
	RESET_REDUCER_DISTRIBUTION_REGION = "@distributionRegion/RESET_REDUCER_DISTRIBUTION_REGION",
}

export interface DistributionRegionState {
	readonly distributionRegion: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetDistributionRegion {
	type: typeof DistributionRegionTypes.GET_DISTRIBUTION_REGION;
	payload: {
		request: DistributionRegionFilterRequest;
	};
}

export interface SaveDistributionRegion {
	type: typeof DistributionRegionTypes.SAVE_DISTRIBUTION_REGION;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerDistributionRegion {
	type: typeof DistributionRegionTypes.RESET_REDUCER_DISTRIBUTION_REGION;
}

export type DistributionRegionActionTypes =
	| GetDistributionRegion
	| SaveDistributionRegion
	| ResetReducerDistributionRegion;
